import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { environment } from 'src/environments/environment';

const PKEY = environment.storage + '_token';

export class Variable {
  key: string = '';
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService) {}

  get<T>(key: string): T | null {
    const data = this.storage.get(PKEY) ?? {};
    
    return data[key] ?? null;
  }

  set<T>(key: string, value: T): void {
    const data = this.storage.get(PKEY) ?? {};
    data[key] = value;
    this.storage.set(PKEY, data);
  }

  getChild<T>(key: string, childKey: string): T | null {
    const data: any = this.get(key);
    return data ? data[childKey] ?? null : null;
  }

  setChild<T>(key: string, child: Variable): void {
    const data: any = this.get(key) ?? {};
    data[child.key] = child.value;
    this.set(key, data);
  }

  remove(key: string): void {
    this.storage.remove(PKEY);
  }

  clearAll(): void {
    this.storage.clear();
  }

  cleanStorage(key?: string): void {
    if (key) {
      this.storage.remove(key);
      return;
    }

    this.storage.remove(PKEY);
  }
}
